// app/middleware/notFoundAmericas.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "germany") {
    throw createError({ statusCode: 404 });
  }
});
